export default "__VITE_ASSET__BvYBf3C$__"